var _defs, _style, _use, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    width: 38,
    height: 38,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter-fill-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 38,
    height: 38,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmAQMAAACS83vtAAAAAXNSR0IB2cksfwAAAANQTFRFFRcYq3hAgQAAAA9JREFUeJxjZAABxmFNAgASQgAn3Cz3fQAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 0,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m33 10.6q-1.5 0.6-3.2 0.8c1.2-0.7 2-1.8 2.5-3q-1.7 0.9-3.6 1.3c-1-1.1-2.5-1.8-4-1.7-3.1 0-5.6 2.4-5.6 5.5q0 0.7 0.1 1.3c-4.6-0.3-8.7-2.5-11.4-5.8-0.5 0.8-0.8 1.8-0.8 2.8 0 1.9 1 3.6 2.5 4.6-0.9 0-1.7-0.3-2.5-0.7q0 0 0 0.1c0 2.7 1.9 4.9 4.4 5.4q-0.7 0.2-1.4 0.2-0.6 0-1.1-0.1c0.7 2.2 2.8 3.8 5.2 3.9-1.9 1.5-4.4 2.4-6.9 2.4q-0.6 0-1.3-0.1c2.5 1.6 5.5 2.5 8.5 2.5 10.2 0 15.8-8.5 15.8-15.8q0-0.4 0-0.8c1.1-0.8 2.1-1.7 2.8-2.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFill);
export default __webpack_public_path__ + "static/media/twitter-fill.bce0421bb1b946e8e6cbaabf9e703ec6.svg";
export { ForwardRef as ReactComponent };